import { useCallback, useMemo } from 'react';
import {
	useActiveRightSidebarState,
	useRightSidebarController,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import {
	CONVERSATION_ASSISTANT_CONTAINER_ID,
	CONVERSATION_ASSISTANT_CONTAINER_WIDTH,
} from '@atlassian/conversation-assistant/utils';

export const useConversationAssistantSidebarApi = ({
	width = CONVERSATION_ASSISTANT_CONTAINER_WIDTH,
	isMinimised,
	toTop,
}: {
	width?: number;
	isMinimised?: boolean;
	toTop?: boolean;
}) => {
	const { openRightSidebar, closeRightSidebar, closeCurrentRightSidebar } =
		useRightSidebarController();
	const { panelId, isCollapsed } = useActiveRightSidebarState() || {};

	const isActive = panelId === CONVERSATION_ASSISTANT_CONTAINER_ID && !isCollapsed;
	const isOtherPanelActive = panelId !== CONVERSATION_ASSISTANT_CONTAINER_ID && !isCollapsed;

	const openSidebar = useCallback(
		(newWidth?: number) => {
			isOtherPanelActive && closeCurrentRightSidebar();
			openRightSidebar(CONVERSATION_ASSISTANT_CONTAINER_ID, newWidth ?? width, isMinimised, toTop);
		},
		[closeCurrentRightSidebar, isOtherPanelActive, openRightSidebar, width, isMinimised, toTop],
	);

	const closeSidebar = useCallback(() => {
		closeRightSidebar(CONVERSATION_ASSISTANT_CONTAINER_ID);
	}, [closeRightSidebar]);

	return useMemo(
		() => ({
			isSidebarOpen: () => isActive,
			openSidebar,
			closeSidebar,
		}),
		[isActive, openSidebar, closeSidebar],
	);
};
